module.exports = __webpack_public_path__ + "static/media/steven-roe.176ecfb6.jpg";